import { HEADERS } from 'src/constants/headers';
import {
    ACTION_ERROR,
    AI_CALL_MAX_WAIT_MS,
    AI_CALL_POLL_INTERVAL_MS,
    AI_CALL_STATUS,
} from 'src/modules/assistant/constants/actions';
import {
    actionFailure,
    createActionHandler,
} from 'src/modules/assistant/actions/createActionHandler';
import { TActionDraft } from 'src/modules/assistant/types/message';

interface TAICallStatus {
    status: string;
    summary?: string;
    [field: string]: unknown;
}

const wait = (ms: number, signal?: AbortSignal): Promise<boolean> =>
    new Promise((resolve) => {
        if (signal?.aborted) {
            resolve(false);
            return;
        }
        let timer: number;
        const onAbort = () => {
            window.clearTimeout(timer);
            resolve(false);
        };
        timer = window.setTimeout(() => {
            signal?.removeEventListener('abort', onAbort);
            resolve(true);
        }, ms);
        signal?.addEventListener('abort', onAbort, { once: true });
    });

export const aiCall = createActionHandler<TActionDraft>({
    validate: () => true,
    execute: async (_, { api, lead, leadActions, signal }) => {
        const startedCall = await leadActions.makeAICall(lead._id);
        if (!startedCall || !startedCall.callId) return false;

        const startedAt = Date.now();
        while (Date.now() - startedAt < AI_CALL_MAX_WAIT_MS) {
            if (!(await wait(AI_CALL_POLL_INTERVAL_MS, signal)))
                return actionFailure(ACTION_ERROR.ABORTED);
            const response = await api.get(
                `/leads/aiCall/${startedCall.callId}/status`,
                HEADERS()
            );
            const callStatus = response.data.data as TAICallStatus;
            if (callStatus.status === AI_CALL_STATUS.COMPLETED)
                return { ok: true, data: callStatus };
            if (callStatus.status === AI_CALL_STATUS.FAILED) return false;
        }
        return actionFailure(ACTION_ERROR.TIMEOUT);
    },
});
